import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Reason } from "@models/reason.model";
import { ReasonsService } from "@services/reasons.service";
import { Issue } from "@models/issue.model";
import { ModalComponent } from "@app/shared/components";
import { PermissionService } from "@app/authentication/services/permission.service";
import { Log } from 'ng2-logger';
import { IssuesService } from '@app/core/services/issues.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastsManager } from "@app/shared/util/toastr.service";

@Component({
    selector: 'app-issue-create-modal',
    templateUrl: './issue-create-modal.component.html',
    styleUrls: ['./issue-create-modal.component.scss']
})
export class IssueCreateModalComponent implements OnInit {

    _logger = Log.create(IssueCreateModalComponent.name);
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    issueForm: UntypedFormGroup;
    issue = new Issue();
    showValidations = false;
    reasons: Reason[];
    isLoading = false;

    constructor(private permissionService: PermissionService,
                private reasonService: ReasonsService,
                private issueService: IssuesService,
                private toastr: ToastsManager,
                private translationService: TranslateService) {
    }

    open(issue = new Issue()) {
        this.reset();
        this.isLoading = true;
        this.getIssueDetails(issue.id)
        this.modal.open();
    }

    ngOnInit() {
        this.issueForm = new UntypedFormGroup({
            reasonId: new UntypedFormControl('', [<any>Validators.required]),
            description: new UntypedFormControl('', [<any>Validators.required]),
            isReplacementOrdered: new UntypedFormControl(false, [<any>Validators.required]),
            line: new UntypedFormControl('', [<any>Validators.required]),
            status: new UntypedFormControl(''),
            createdBy: new UntypedFormControl(''),
            createdAt: new UntypedFormControl('')
        });
        this.getReasons();
    }

    get isViewMode() {
        return !!this.issue.id;
    }

    private getIssueDetails(id: number) {
        this._logger.info("getIssueDetails:: Retrieving issue details for issueId", id);
        this.issueService.getIssueById(id).subscribe(
            (data) => {
                this._logger.info("getIssueDetails:: API Returned data", data);
                this.issue = data;
                this.isLoading = false;
                this.loadFormValue(this.issue);
            },
            (error) => {
                this._logger.error("getIssueDetails:: API Returned error", error);
                this.isLoading = false;
                this.toastr.error(this.translationService.instant('atom.tool-returns.toasts.couldNotOpenIssue'));
            }
        )
    }

    private getReasons() {
        this.reasonService.getAllIReasons().subscribe((data) => {
            this.reasons = data.items;
        });
    }

    private reset() {
        this.showValidations = false;
        this.issueForm.reset();
    }

    private loadFormValue(issue) {
        this.issue = issue;
        this.issueForm.setValue({
            reasonId: issue.reason.id,
            description: issue.description,
            createdAt: issue.createdAt,
            createdBy: issue.user.fullName,
            status: issue.status,
            line: issue.line.name,
            isReplacementOrdered: issue.isReplacementOrdered
        });
    }

    shouldRenderModifiers() {
        return this.permissionService.hasHasPermissionForFeature('VIEW_REASONS');
    }
}
